

/** g工具JS */
export default {
  handleText(text){
    if(!text){
      return text
    }
    text = text.replace(/\\n|\\r/g,"")
    let p = /(<span class=\"fontCR\">(.*?)<\/span>)/g
    text = text.replace(p,"$2")
    return text.replace(/<ROGER>(.*?)<\/ROGER>/g,"<span class=\"fontCR\">$1</span>")
  },
  handleRmoveText(text){
    if(!text){
      return text
    }
    let p = /(<span style=\"color:#FF0000\">(.*?)<\/span>)/g
    text = text.replace(p,"$2")

    let p2 = /(<span class=\"fontCR\">(.*?)<\/span>)/g
    text = text.replace(p2,"$2")
    return text.replace(/<ROGER>(.*?)<\/ROGER>/g,"$1")
  },
}
